import { getFillByLot } from "./Manzana2Div1";

export const Manzana38Div1 = ({lands, landSelector = (_e, _id) => {}, selected, style}) => {

    const findLandById = (id) => {
        return lands.filter(l => l.id === id)[0];
    }

    const findLandByLot = (lot) => {
        return lands.filter(l => l.lote === lot)[0];
    }

    const getFill = (id) => {
        const land = lands.filter(l => l.id === id)[0];
        const disabledColor = "rgba(223, 250, 255, 0.48)";
        const normalColor = "#0096B3";
        const selectedColor = "#DFFAFF";

        if (!land) {
            return disabledColor; // disabled
        }

        if (selected) {
            if (id === selected.id) {
                return selectedColor;
            }
        }

        if (land.status !== 'on_sale') {
            return disabledColor; // disabled
        } else {
            return normalColor; // normal color
        }
    }

    if (!lands) {
        return <></>
    }

    return (
        <svg width={style?.width || "1219"} height={style?.height || "941"} viewBox="0 0 1219 941" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="1219" height="941" fill="url(#pattern0_1874_3369)"/>
        <path 
            className="cursor-pointer"
            onClick={(e) => landSelector(e, findLandByLot('6'))}
            d="M632.723 422.671L578.477 434.361L596.144 503.437L652.933 490.684L632.723 422.671Z" 
            fill={getFillByLot("6", selected, lands)}
            fillOpacity="0.64" 
            stroke="#6D6859" 
            stroke-opacity="0.6"
        />
        <path 
            className="cursor-pointer"
            onClick={(e) => landSelector(e, findLandByLot('7'))}
            d="M620.114 577.262L675.641 565.021L652.925 490.817L602.447 502.175L620.114 577.262Z" 
            fill={getFillByLot("7", selected, lands)}
            fillOpacity="0.64" 
            stroke="#6D6859" 
            stroke-opacity="0.6"
        />
        <path 
            className="cursor-pointer"
            onClick={(e) => landSelector(e, findLandByLot('2'))}
            d="M481.3 456.744L520.421 447.911L535.564 518.827L460.477 534.986L481.3 456.744Z" 
            fill={getFillByLot("2", selected, lands)} 
            fillOpacity="0.64" 
            stroke="#6D6859" 
            stroke-opacity="0.6"
        />
        <path 
            className="cursor-pointer"
            onClick={(e) => landSelector(e, findLandByLot('1'))}
            d="M507.803 602.589L429.561 620.8L459.988 535.104L491.502 528.676L507.803 602.589Z" 
            fill={getFillByLot("1", selected, lands)} 
            fillOpacity="0.64" 
            stroke="#6D6859" 
            stroke-opacity="0.6"
        />
        <path 
            className="cursor-pointer"
            onClick={(e) => landSelector(e, findLandByLot('3'))}
            d="M507.499 601.87L563.326 589.157L547.222 516.056L491.394 528.769L507.499 601.87Z" 
            fill={getFillByLot("3", selected, lands)} 
            fillOpacity="0.64" 
            stroke="#6D6859" 
            stroke-opacity="0.6"
        />
        <path 
            className="cursor-pointer"
            onClick={(e) => landSelector(e, findLandByLot('5'))}
            d="M563.071 589.252L620.119 577.427L602.897 502.176L546.925 515.076L563.071 589.252Z" 
            fill={getFillByLot("5", selected, lands)} 
            fillOpacity="0.64" 
            stroke="#6D6859" 
            stroke-opacity="0.6"
        />
        <path 
            className="cursor-pointer"
            onClick={(e) => landSelector(e, findLandByLot('4'))}
            d="M520.425 447.878L578.475 434.66L596.143 503.437L535.568 518.581L520.425 447.878Z" 
            fill={getFillByLot("4", selected, lands)}
            fillOpacity="0.64" 
            stroke="#6D6859" 
            stroke-opacity="0.6"
        />
        <defs>
        <pattern id="pattern0_1874_3369" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use href="#image0_1874_3369" transform="matrix(0.00177481 0 0 0.0023003 -4.30739 -0.962065)"/>
        </pattern>
        <image id="image0_1874_3369" width="4096" height="2304" href="/mz1.png"/>
        </defs>
        </svg>
    );
}